import { render, staticRenderFns } from "./episode.column.vue?vue&type=template&id=77aba221&"
import script from "./episode.column.vue?vue&type=script&lang=ts&"
export * from "./episode.column.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports